import React, { useState, useRef } from 'react';
import StoryContext from '../contexts/StoryContext';
import StoryQ1 from './Access/StoryQ1';
import StoryQ2 from './Access/StoryQ2';
import StoryQ3 from './Access/StoryQ3';
import colors from '../modules/colors';
import CallToAction from './Access/CallToAction';
import PrintToPDF from './PrintToPDF';
import Resources from './Resources';
import CallToActionButton from './CallToActionButton';

function AccessStory() {
  const [selectedState, setSelectedState] = useState(null);
  const ref = useRef(null);
  return (
    <StoryContext.Provider value={{
      selectedState,
      setSelectedState,
      primaryColor: colors.purple,
      darkColor: colors.darkPurple,
      lightColor: colors.lightPurple,
      secondaryColor: colors.grey,
      contrastColor: colors.taupe,
      messageBackgroundColor: colors.taupe,
      selectionColor: colors.grey,
      hoverColor: colors.taupe,
    }}
    >
      <CallToActionButton targetRef={ref} />
      <StoryQ1 />
      <StoryQ2 />
      <StoryQ3 />
      <div ref={ref} />
      <CallToAction />
      <PrintToPDF />
      <Resources />
    </StoryContext.Provider>
  );
}

export default AccessStory;
